// /use-cases — every use-case page
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Seo from '../site/Seo';
import CtaBand from '../site/CtaBand';
import { USE_CASE_PAGES } from './useCaseData';
import { FREE_NOTE, StartButtons } from './UseCasePage';
import './useCases.css';

export default function UseCasesIndex() {
  return (
    <>
      <Seo
        title="What people use Bumpups for: lectures, lessons, game film, meetings | Bumpups"
        description="Students, teachers, coaches, creators and teams use Bumpups to get chapters, notes and answers from their videos. See each use case on a real video."
      />
      <section className="uc-hero mk-hero-bg">
        <div className="mk-container">
          <p className="mk-eyebrow">Use cases</p>
          <h1 className="mk-h1 uc-title">One tool for every video you need to get through</h1>
          <p className="mk-lead">Lectures, lesson recordings, game film, episodes, meetings and interviews. See what Bumpups makes from each, on a real video.</p>
          <StartButtons />
          <p className="mk-note">{FREE_NOTE}</p>
        </div>
      </section>
      <section className="mk-section mk-section--tight">
        <div className="mk-container">
          <div className="mk-grid mk-grid--3">
            {USE_CASE_PAGES.map(p => (
              <Link key={p.slug} to={`/use-cases/${p.slug}`} className="mk-card uc-card">
                <span className="mk-icon"><FontAwesomeIcon icon={p.icon} /></span>
                <h2 className="mk-h3">{p.label}</h2>
                <p className="mk-text">{p.summary}</p>
                <span className="uc-card-more">See an example →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
